import React from 'react';
export function PresentationFrame({
  children
}: {
  children: ReactNode;
}) {
  return <div className="h-[100dvh] w-full bg-slate-100 flex items-center justify-center relative overflow-hidden p-4 md:p-8" data-id="element-99">
      {/* Document page shadow wrapper */}
      <div className="relative w-full h-full max-w-[1800px] mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col border border-slate-200" data-id="element-100">
        {/* Top accent line */}
        <div className="h-1.5 w-full bg-gradient-to-r from-minerva-blue via-minerva-cyan to-snakker-purple" data-id="element-101" />
        {children}
      </div>
    </div>;
}